import React, { useEffect, useState } from "react";
import Webmenu from "../../../layouts/webmenu";
import Topbar from "../../../layouts/topbar";
import { useDispatch, useSelector } from "react-redux";
import { getCustomerTypeById, saveCustomerType, updateCustomerType } from "../../../actions/CustomerTypeActions";
import { useParams } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { getInsuranceCompanyById, updateInsuranceCompany } from "../../../actions/InsuranceCompanyActions";
import Toast from "../../../components/Toast";
import Mobilemenu from "../../../layouts/mobile-menu";

function EditInsuranceCompany() {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const params = useParams();

    const [name, setName] = useState('');
    const [vat, setVat] = useState('');
    const [phone, setPhone] = useState('');
    const [crtn, setCrtn] = useState('');
    const [address, setAddress] = useState('');

    useEffect(() => {
        dispatch(getInsuranceCompanyById(params.id));
    }, [])

    const insuranceCompany = useSelector(state => state?.insuranceCompany?.insuranceCompany);

    useEffect(() => {
        if (Object.keys(insuranceCompany).length > 0) {
            setName(insuranceCompany.contact_name);
        }
    }, [insuranceCompany])

    const save = () => {
        if (name.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Name is Required!'
            })
        } else {
            let data = {
                name: name,
                vat: vat,
                phone: phone,
                crtn: crtn,
                address: address,
            }
            dispatch(updateInsuranceCompany(data, params.id));
        }
        // // window.location.href = ('/insuranceCompany')
    }
    return (
        <React.Fragment>
            <Mobilemenu />
            <div className="content-body d-flex">
                <Webmenu />
                <div className="content">
                    <Topbar />
                    <div className="intro-y d-flex align-items-center mt-8">
                        <h2 className="fs-lg fw-medium me-auto">
                            Edit Insurance Company
                        </h2>
                    </div>
                    <div className="grid columns-12 gap-6 mt-5">
                        <div className="intro-y g-col-12 g-col-lg-6">
                            {/* <!-- BEGIN: Form Layout --> */}
                            <div className="intro-y box p-5">
                            <div>
                                        <label for="crud-form-1" className="form-label">Insurance Company Name</label>
                                        <input id="crud-form-1" value={name} onChange={(e) => setName(e.target.value)} type="text" className="form-control w-full" placeholder={name == "" ? "Enter Name..." : (e) => e.target.value} />
                                    </div>
                                    <div>
                                        <label for="crud-form-1" className="form-label">Phone</label>
                                        <input id="crud-form-1" value={phone} onChange={(e) => setPhone(e.target.value)} type="text" className="form-control w-full" placeholder={phone == "" ? "Enter Phone..." : (e) => e.target.value} />
                                    </div>
                                    <div>
                                        <label for="crud-form-1" className="form-label">Vat Trn #</label>
                                        <input id="crud-form-1" value={vat} onChange={(e) => setVat(e.target.value)} type="text" className="form-control w-full" placeholder={name == "" ? "Enter Vat..." : (e) => e.target.value} />
                                    </div>
                                    <div>
                                        <label for="crud-form-1" className="form-label">CRTN #</label>
                                        <input id="crud-form-1" value={crtn} onChange={(e) => setCrtn(e.target.value)} type="text" className="form-control w-full" placeholder={name == "" ? "Enter CRTN..." : (e) => e.target.value} />
                                    </div>
                                    <div>
                                        <label for="crud-form-1" className="form-label">Insurance Company Name</label>
                                        <textarea id="note" onChange={(e) => setAddress(e.target.value)} value={address} name="note" type="text" rows={4} className="form-control" placeholder="Enter Address" />
                                    </div>
                                {/* <div className="mt-3">
                                    <label>Status</label>
                                    <div className="form-check form-switch mt-2">
                                        <input type="checkbox" className="form-check-input"/>
                                    </div>
                                </div> */}
                                <div className="text-end mt-5">
                                    <button type="button" onClick={() => navigate('/insuranceCompany')} className="btn btn-outline-secondary w-24 me-1">Back</button>
                                    <button type="button" onClick={save} className="btn btn-primary w-24">Update</button>
                                </div>
                            </div>
                            {/* <!-- END: Form Layout --> */}
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default EditInsuranceCompany;